// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1316":"419efe85","4120":"5f084b81","5135":"62db50a7"}[chunkId] + ".chunk.css";
};